import { mapState } from 'vuex'

import { freeVersion } from '@/constants'

import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'

import ManagerUserModal from '@/modals/ManagerUserModal'
import SubscriptionModal from '@/modals/SubscriptionModal'
import SosButton from '@/components/SosButton'

import groupplaceholder from '@/assets/images/groupplaceholder.png'

const fillArraySequentially = length => Array.from({ length }, (_, index) => String(index + 1))

const size = 10
const step = 3

export default {
  name: 'ManagerUsers',

  components: {
    ManagerUserModal,
    SubscriptionModal,
    'sos-button': SosButton,
  },

  mixins: [SubscriptionModalMixin],

  data () {
    return {
      pageNumber: 0, // default to page 0

      search: '',
      groupplaceholder: groupplaceholder,
    }
  },

  computed: {
    // 'groups',
    ...mapState({
      userSession: state => state.app.userSession,
      managerUsers: state => state.app.managerUsers,
      loadingGroups: state => state.app.loadingGroups,
      loadingGroupsProgress: state => state.app.loadingGroupsProgress,
      loadingUsers: state => state.app.loadingUsers,
      loadingUsersProgress: state => state.app.loadingUsersProgress,
      loadingUsersMax: state => state.app.loadingUsersMax,
    }),

    pageDescription ()
    {
      const isError = this.loadingGroups === 'ERROR_PROFILE_FB' || this.loadingGroups === 'ERROR_PROFILE_API' || this.loadingGroups === 'ERROR_PLANS_API' || this.loadingGroups === 'ERROR_PROFILE_NOT_FOUND'
      const isExiting = this.loadingGroups === 'LEAVING' || this.loadingUsers === 'LEAVING'
      const isWaiting = this.loadingGroups === 'WAITING' && this.loadingUsers === 'WAITING'
      const isLoading = this.loadingGroups === 'LOADING' || this.loadingUsers === 'LOADING'

      return (
        isError ? 'Erro!' : (
          isExiting ? 'Saindo...' : (
            isWaiting ? 'Inicializando...' : (
              isLoading ? 'Carregando...' : (
                this.usuarios.lista.length === 0 ? 'Você não está gerenciando nenhum usuário.' : (
                  this.usuarios.lista.length === 1 ? 'Você está gerenciando 1 usuário.' : (
                    `Você está gerenciando ${this.usuarios.lista.length} usuários.`
                  )
                )
              )
            )
          )
        )
      )
    },

    pagesCount: function () {
      return Math.ceil(this.usuarios.lista.length / size)
    },

    // O navigator tem até 11 páginas?
    isFullPagination: function () {
      return this.pagesCount < (step * 2) + 6
    },

    // A página atual é menor que 7? Então está no começo da navegação.
    isPaginationStarting: function () {
      return this.pageNumber < (step * 2) // + 1
    },

    // A página atual é maior que TOTAL - 6, exemplo: "Em 30 páginas, está entre a página 25 e 30", então está no final da navegação.
    isPaginationEnding: function () {
      return this.pageNumber > this.pagesCount - (step * 2)
    },

    startPage: function () {
      return this.isFullPagination ? (
        0
      ) : (
        this.isPaginationStarting ? (
          0
        ) : (
          this.isPaginationEnding ? (
            this.pagesCount - (step * 2) - 2
          ) : (
            this.pageNumber - step
          )
        )
      )
    },

    endPage: function () {
      return this.isFullPagination ? (
        this.pagesCount + 1
      ) : (
        this.isPaginationStarting ? (
          ((step * 2) + 4) - 1 /* Senhor Jesus */
        ) : (
          this.isPaginationEnding ? (
            this.pagesCount + 1
          ) : (
            this.pageNumber + step + 1
          )
        )
      )
    },

    pages: function () {
      // [24/01/25] console.log('::: pages:', this.startPage, this.endPage)

      return fillArraySequentially(this.pagesCount).slice(this.startPage, this.endPage)
    },

    paginatedData: function ()
    {
      const start = this.pageNumber * size
      const end = start + size

      return {
        lista: this.usuarios.lista.slice(start, end),
        resultados: this.usuarios.resultados,
      }
    },

    usuarios: function ()
    {
      let listaFiltrada = []

      const lista = !!this.managerUsers === true && Array.isArray(this.managerUsers) && this.managerUsers.length > 0 ? this.managerUsers : []

      // console.log('::: USERS > LIST:', lista)

      const filter = this.search.trim()
      const isSearch = lista.length > 1 && filter.length >= 3

      if (!isSearch)
      {
        /* if (lista.length > 0) {
          lista.sort((a, b) => a.user.nome.localeCompare(b.user.nome))
          lista.sort((a, b) => b.isMe - a.isMe)
        } */

        if (lista.length > 0) {
          lista.sort((a, b) => {
            const isMeA = a.userID === this.userSession.uid
            const isMeB = b.userID === this.userSession.uid
            // Compare by isMe first
            if (isMeA && !isMeB) return -1
            if (!isMeA && isMeB) return 1
            // If both have the same isMe value, compare by user.nome
            return a.user.nome.localeCompare(b.user.nome)
          })
        }
      }
      else
      {
        listaFiltrada = lista.filter(user => {
          const nome = user.user.nome
          const email = user.user.email
          const cpf = user.user.cpf
          const cnpj = user?.user?.cnpj || ''
          const tel = user.user.tel

          const cpfNumbers = cpf.length > 0 ? cpf.replace(/[^0-9]/g, '') : ''
          const cnpjNumbers = cnpj.length > 0 ? cnpj.replace(/[^0-9]/g, '') : ''
          const telNumbers = tel.length > 0 ? tel.replace(/[^0-9]/g, '') : ''

          const findGroup = user.userGroups.findIndex(item => (item.groupName.length > 0 ? (item.groupName.toUpperCase().indexOf(filter.toUpperCase()) !== -1) : false))

          return (
            (nome.length > 0 ? (nome.toUpperCase().indexOf(filter.toUpperCase()) !== -1) : false) ||
            (email.length > 0 ? (email.toUpperCase().indexOf(filter.toUpperCase()) !== -1) : false) ||
            (cpf.length > 0 ? (cpf.indexOf(filter) !== -1) : false) ||
            (cnpj.length > 0 ? (cnpj.indexOf(filter) !== -1) : false) ||
            (tel.length > 0 ? (tel.indexOf(filter) !== -1) : false) ||

            (cpfNumbers.length > 0 ? (cpfNumbers.indexOf(filter) !== -1) : false) ||
            (cnpjNumbers.length > 0 ? (cnpjNumbers.indexOf(filter) !== -1) : false) ||
            (telNumbers.length > 0 ? (telNumbers.indexOf(filter) !== -1) : false) ||

            findGroup !== -1
          )
        })

        /* if (listaFiltrada.length > 0) {
          listaFiltrada.sort((a, b) => a.user.nome.localeCompare(b.user.nome))
          listaFiltrada.sort((a, b) => b.isMe - a.isMe)
        } */

        if (listaFiltrada.length > 0) {
          listaFiltrada.sort((a, b) => {
            const isMeA = a.userID === this.userSession.uid
            const isMeB = b.userID === this.userSession.uid
            // Compare by isMe first
            if (isMeA && !isMeB) return -1
            if (!isMeA && isMeB) return 1
            // If both have the same isMe value, compare by user.nome
            return a.user.nome.localeCompare(b.user.nome)
          })
        }
      }

      return {
        isSearch,
        lista: isSearch ? (listaFiltrada.length > 0 ? listaFiltrada : []) : lista,
        // resultados: isSearch ? listaFiltrada.length : -1,
        resultados: isSearch ? listaFiltrada.length : lista.length,
      }
    },
  },

  watch: {
    // [24/01/25] '$store.state.app.loadingUsers': function () {
      // [24/01/25] console.log('::: loadingUsers[watch]:', this.$store.state.app.loadingUsers)
    // [24/01/25] },

    search: {
      immediate: true,
      handler (searchNew, searchOld)
      {
        const oldFilter = String(searchOld).trim()
        const newFilter = String(searchNew).trim()

        const managerUsers = !!this.managerUsers === true && Array.isArray(this.managerUsers) ? this.managerUsers : []

        const isOldSearch = managerUsers.length > 1 && oldFilter.length >= 3
        const isNewSearch = managerUsers.length > 1 && newFilter.length >= 3

        if (isOldSearch === false && isNewSearch === true) {
          // [24/01/25] console.log('::: search[watch]: Modo de busca ativado.')
          this.pageNumber = 0
        } else if (isOldSearch === true && isNewSearch === false) {
          // [24/01/25] console.log('::: search[watch]: Modo de busca desativado.')
        } else {
          // [24/01/25] console.log('::: search[watch]: Modo de busca ativado + Atualizou a busca...')
          this.pageNumber = 0
        }

        // console.log('::: search[watch] > old:', oldFilter, isOldSearch)
        // console.log('::: search[watch] > new:', newFilter, isNewSearch)
      },
    },
  },

  methods: {
    prevPage () {
      this.pageNumber = this.pageNumber > 0 ? (this.pageNumber - 1) : 0
      // [24/01/25] console.log('::: prevPage:', { pageNumber: this.pageNumber, pagesCount: this.pagesCount, startPage: this.startPage, endPage: this.endPage })
    },

    nextPage () {
      this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? (this.pagesCount - 1) : this.pageNumber + 1
      // [24/01/25] console.log('::: nextPage:', { pageNumber: this.pageNumber, pagesCount: this.pagesCount, startPage: this.startPage, endPage: this.endPage })
    },

    setPage (pageNumber) {
      this.pageNumber = Number(pageNumber) - 1
      // [24/01/25] console.log('::: setPage:', pageNumber)
    },

    handleView (groupID) {
      this.$router.push(`/admin/grupos/${groupID}/escalas`)
    },

    editUser (userID)
    {
      //
      //
      //

      if (freeVersion === false && this.userSession.userCapabilities.editorUsuarios !== true)
      {
        const planName = this.userSession.planName.name

        const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo editar usuários. Preciso de ajuda." target="_blank">suporte</a>`
        const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

        if (this.userSession.planOrigin === 'CUSTOM') {
          // Plano personalizado
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas a gestão de usuários não está liberada.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'COUPON') {
          // Cupom ativo
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas a gestão de usuários não está liberada.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          // Assinatura ativa na vindi
          this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para editar o usuário, assine o Plano Bronze ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          // Assinatura ativa, mas com alguma pendência ou erro na vindi
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e a gestão de usuários não está liberada.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            // Plano da vindi expirado
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e a gestão de usuários não está liberada.</p>${textSupport}`)
          } else {
            // Plano gratuíto ou alcançou alguma condição desconhecida
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e a gestão de usuários não está liberada.</p>${textSupport}`)
          }
        }

        return false
      }

      //
      //
      //

      this.$refs.userModal.open(userID)
    },
  },
}
